var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "./Base";
var Emoji = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props),
        React.createElement("g", { fill: "#3d3d36", fillRule: "evenodd" },
            React.createElement("path", { d: "m9 16.5c-4.14213562 0-7.5-3.3578644-7.5-7.5 0-4.14213562 3.35786438-7.5 7.5-7.5 4.1421356 0 7.5 3.35786438 7.5 7.5 0 4.1421356-3.3578644 7.5-7.5 7.5zm0-1c3.5898509 0 6.5-2.9101491 6.5-6.5 0-3.58985087-2.9101491-6.5-6.5-6.5-3.58985087 0-6.5 2.91014913-6.5 6.5 0 3.5898509 2.91014913 6.5 6.5 6.5z", fillRule: "nonzero" }),
            React.createElement("path", { d: "m7.5 15c-.27614237 0-.5-.2238576-.5-.5s.22385763-.5.5-.5c1.38071187 0 2.5-1.1192881 2.5-2.5s-1.11928813-2.5-2.5-2.5c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5c1.93299662 0 3.5 1.56700338 3.5 3.5 0 1.9329966-1.56700338 3.5-3.5 3.5z", fillRule: "nonzero", transform: "matrix(0 1 -1 0 20.5 2.5)" }),
            React.createElement("circle", { cx: "6.25", cy: "7.25", r: "1" }),
            React.createElement("circle", { cx: "11.75", cy: "7.25", r: "1" }))));
};
export default Emoji;
